import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../utils/helper";

export const specialtiesServerApi = createApi({
  reducerPath: "specialtiesServerApi",
  baseQuery: fetchBaseQuery({ baseUrl: process?.env?.REACT_APP_API_HOST_URL }),
  tagTypes: ["Specialties"],
  endpoints: (builder) => ({
    getSpecialties: builder.query({
      query: () => ({
        url: "/core/specialties",
        headers: getHeaders(),
      }),
      providesTags: ["Specialties"],
    }),
  }),
});

export const { useGetSpecialtiesQuery } = specialtiesServerApi;
